import { render } from "./CadastroTransportador.vue?vue&type=template&id=39188c5f"
import script from "./CadastroTransportador.vue?vue&type=script&lang=ts"
export * from "./CadastroTransportador.vue?vue&type=script&lang=ts"
script.render = render

export default script